import { on } from "delegated-events";
import { gsap } from "gsap";

const blocks = new Map();

on(
  "mouseover",
  ".initiative-block",
  (e) => {
    const block = e.currentTarget.closest(".initiative-block");
    const blockId = block.dataset.blockId;
    const screen = block.querySelector(".block-screen");
    const card = block.querySelector(".block-card");
    const content = block.querySelector(".block-content");
    const line = block.querySelector(".block-line");
    const arrow = block.querySelector(".block-arrow");

    const path = line.querySelector(".block-line-path");
    const length = path.getTotalLength();
    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = 0;

    const existingTimeline = blocks.get(blockId);

    if (existingTimeline) {
      existingTimeline.timeScale(1).play();
    } else {
      const timeline = gsap
        .timeline()
        .fromTo(screen, { opacity: 0 }, { opacity: 1, duration: 0.3 })
        .fromTo(
          card,
          { y: 0 },
          {
            y: () => {
              return content.offsetHeight * -1;
            },
            duration: 0.3,
          },
          "<50%",
        )
        .fromTo(content, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.4 }, "<50%")
        .fromTo(
          path,
          {
            strokeDashoffset: 0,
          },
          {
            strokeDashoffset: -length,
            duration: 0.6,
            ease: "power1.inOut",
          },
          "<50%",
        )
        .fromTo(arrow, { opacity: 0, x: -10, y: 10 }, { opacity: 1, x: 0, y: 0, duration: 0.4 }, "<50%");

      blocks.set(blockId, timeline);
    }
  },
  { capture: true },
);

on(
  "mouseout",
  ".initiative-block",
  async (e) => {
    const block = e.currentTarget.closest(".initiative-block");
    const blockId = block.dataset.blockId;

    const timeline = blocks.get(blockId);

    timeline.timeScale(1.5).reverse();
  },
  { capture: true },
);
